import PropTypes from 'prop-types';
import React from 'react';

import * as S from './Video.styles';

export const Video = ({ allowControl, allowCookie, videoId }) => {
  if (!videoId) {
    return null;
  }

  const controls = allowControl ? '' : '?controls=0';
  const cookie = allowCookie ? '' : '-nocookie';
  const embedUrl = `https://www.youtube${cookie}.com/embed/${videoId}${controls}`;

  return (
    <S.Container>
      <S.VideoIframe
        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
        allowFullScreen={true}
        src={embedUrl}
        title='Embedded youtube'
      />
    </S.Container>
  );
};

Video.propTypes = {
  /**
   * Show player controls on the video.
   */
  allowControl: PropTypes.bool,
  /**
   * Enable privacy-enhanced mode.
   */
  allowCookie: PropTypes.bool,
  /**
   * Video ID from Youtube.
   */
  videoId: PropTypes.string.isRequired,
};

Video.defaultProps = {
  allowControl: true,
  allowCookie: true,
};
